export const CustomProjectStep3ElementsIdsEnum = {
    WORK_AREA_STEP3_SECTION: 'workAreaStep3Section',
    WORK_AREA_STEP3_SELECT_ALL_TEMPLATE_BUTTON:
        'workAreaStep3SelectAllTemplateButton',
    WORK_AREA_STEP3_SELECT_ALL_FRAGMENT_BUTTON:
        'workAreaStep3SelectAllFragmentButton',
    WORK_AREA_STEP3_CLEAR_ALL_TEMPLATE_BUTTON:
        'workAreaStep3ClearAllTemplateButton',
    WORK_AREA_STEP3_CLEAR_ALL_FRAGMENT_BUTTON:
        'workAreaStep3ClearAllFragmentButton',
    TOTAL_PRICE_PAGE_STEP3_BLOCK_PDF_BUTTON:
        'totalPricePageStep3BlockPDFButton',
    TOTAL_PRICE_PAGE_STEP3_BLOCK_ALL_TO_CART_BUTTON:
        'totalPricePageStep3BlockAllToCartButton',
    TOTAL_PRICE_PAGE_STEP3_BLOCK_SELECTED_TO_CART_BUTTON:
        'totalPricePageStep3BlockSelectedToCartButton',
} as const;

export type CustomProjectStep3ElementsIdsType =
    (typeof CustomProjectStep3ElementsIdsEnum)[keyof typeof CustomProjectStep3ElementsIdsEnum];
